module.exports = __webpack_public_path__ + "static/Dafodil-01-f6209bca753b1f83688150b8dd8b6cfd.png";